import { Injectable } from '@angular/core';
import { AppConstants } from '@app/app.constants';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  /*
   * Used to get data in storage
   */
  public async get(key: string): Promise<unknown> {
    try {
      const item = localStorage.getItem(this.getNameSpace(key));
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error getting data from storage for key ${key}:`, error);
      throw error;
    }
  }

  /*
   * Used to set data in storage
   */
  public async set(key: string, value: unknown): Promise<void> {
    return localStorage.setItem(this.getNameSpace(key), JSON.stringify(value));
  }

  /*
   * Used to clear all data in storage
   */
  public async clear(): Promise<void> {
    return localStorage.clear();
  }

  /*
   * Used to clear specific data entry in storage
   */
  public async remove(key: string): Promise<void> {
    return localStorage.removeItem(this.getNameSpace(key));
  }

  /*
   * Used to construct the namespace for storage
   */
  private getNameSpace(key: string): string {
    return `${AppConstants.STORAGE_KEY}_${key}`;
  }
}
